import { render, staticRenderFns } from "./PointPagination.vue?vue&type=template&id=5a7175d2&scoped=true&"
import script from "./PointPagination.vue?vue&type=script&lang=js&"
export * from "./PointPagination.vue?vue&type=script&lang=js&"
import style0 from "./PointPagination.vue?vue&type=style&index=0&id=5a7175d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7175d2",
  null
  
)

export default component.exports